import { RestClient } from '../lib/RestClient'

class GaleriaService extends RestClient {
  constructor() {
    super('galeria')
  }

  /**
   * Define anexos de uma galeria
   * @param {*} id Id da Atividade
   * @param {FileList} anexos Anexos
   */
  setAnexos(id, anexos, escola) {
    const form = new FormData()
    for (let anexo of anexos) {
      form.append('anexos[]', anexo, anexo.name)
    }

    return this.request({
      method: 'POST',
      url: `anexos/${id}?escola=${escola}`,
      data: form,
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
  }
  async getAnexos(id, escola) {
    return this.request({
      method: 'GET',
      url: `anexos/${id}?escola=${escola}`,
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
  }
  enviar(id, dados, params = {}) {
    return this.request({
      method: 'post',
      url: `enviar/${id}`,
      data: dados,
      params
    })
  }
  async desativar(id, statusDesativado, selectedEscola) {
    const response = await this.request.put(
      `status/${id}/${statusDesativado}`,
      {
        escola: selectedEscola
      }
    )
    return response.data
  }
  async desativarPorID(id, selectedEscola) {
    const response = await this.request.put(`desativar/${id}`, {
      escola: selectedEscola
    })
    return response.data
  }
  async setCapa(id, data, params = {}) {
    const response = await this.request.put(`capa/${id}`, data, {
      params
    })
    return response
  }
  async getCapa(id, params = {}) {
    const response = await this.request.get(`capa/${id}`, {
      params
    })
    return response.data
  }
}

export const Galeria = new GaleriaService()
